import React from "react";
import { NotAcceptingOrdersBannerContent } from "./notAcceptingOrdersBannerContent";
import { Merchant } from "@/dto/merchant";
import { isBusinessOpen } from "@/utils/isBusinessOpenUtil";

export const NotAcceptingOrdersBanner = ({
  merchant,
}: {
  merchant: Merchant;
}) => {
  if (!merchant) {
    return;
  }
  let isOpen = isBusinessOpen(merchant);

  if (!isOpen || !merchant.isCheckoutEnabled) {
    return <NotAcceptingOrdersBannerContent merchant={merchant} />;
  }

  return null;
};
